import {ofType} from 'redux-observable';
import {Observable} from 'rxjs';
import {mergeMap, catchError} from 'rxjs/operators';
import {reset} from 'redux-form';
import {of} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as InstitutionObservables from 'web-app/react/entities/institutions/epics';
import PlansEntity from 'web-app/react/entities/plans/index';
import {RequestType} from 'web-app/react/entities/factory/constants';
import * as ChildEntityActions from 'web-app/react/entities/children/actions';

import * as Actions from './actions';
import * as API from './api';
import * as Constants from './constants';

// we're using this function to determine loading states for the table of plans for children.
export const fetchChildPlansObservable = (institutionId, childId, startDate) => {
    return Observable.zip(
        PlansEntity.observables[RequestType.FetchAll]({id: childId}),
        InstitutionObservables.fetchOpeningHoursObservable(institutionId),
    ).pipe(
        mergeMap(([plansActions, openingHoursSuccess]) =>
            Observable.of([
                ...plansActions,
                Actions.fetchChildPlansDataSuccess.action({
                    childId,
                    startDate,
                }),
                openingHoursSuccess,
            ]),
        ),
    );
};

const fetchChildPlans = action$ =>
    action$.pipe(
        ofType(Actions.fetchChildPlansData.type),
        mergeMap(({payload}) =>
            fetchChildPlansObservable(payload.institutionId, payload.childId, payload.startDate)
                .pipe(mergeMap(actions => actions))
                .catch(e => Observable.of(Actions.fetchChildPlansDataFailed.action(e))),
        ),
    );

const updateDateOfBirthObservable = (childId, dateOfBirth) =>
    API.updateDateOfBirth(childId, dateOfBirth).pipe(
        mergeMap(() => [
            Actions.addDateOfBirthSuccess.action(),
            ChildEntityActions.fetch.action(childId),
            reset(Constants.SIMPLE_BIRTH_DATE_FORM_NAME),
        ]),
    );

const updateDateOfBirth = action$ =>
    action$.pipe(
        ofType(Actions.addDateOfBirth.type),
        mergeMap(({payload}) => updateDateOfBirthObservable(payload.childId, payload.dateOfBirth)),
        catchError(error => of(Actions.addDateOfBirthFailed.action(error))),
    );

export default combineEpics(fetchChildPlans, updateDateOfBirth);
